import { useDispatch } from 'react-redux';
import { useAppSelector, useEnv, useUpgradeAccountPage } from 'src/hooks';
import { useAccountStatementTrack } from 'src/pages/TransactionReport/AccountStatement/hooks';
import { B2xUserAccountType } from 'src/redux/reducers/mainReducer';

export const useWithdrawal = () => {
  const dispatch = useDispatch();
  const { currentEnv: env } = useEnv();
  const { trackClickWithdraw } = useAccountStatementTrack();
  const { openUpgradeAccountPage } = useUpgradeAccountPage();
  const { isModalOpen, isSubmitting } = useAppSelector(
    state => state.main.withdrawal,
  );
  const userAccountType = useAppSelector(
    state => state.main.b2xUser?.account_type,
  );

  const toggleModal = () => {
    dispatch({
      type: 'SET_WITHDRAWAL',
      payload: {
        isModalOpen: !isModalOpen,
      },
    });
  };

  const openWithdrawModal = () => {
    trackClickWithdraw(env);
    if (userAccountType !== B2xUserAccountType.APPROVED) {
      openUpgradeAccountPage();
    } else {
      toggleModal();
    }
  };

  return { toggleModal, openWithdrawModal, isModalOpen, isSubmitting };
};
